import React from "react";
import { Users, Flame, Home, Sparkles } from "lucide-react";
import { EXPERIENCES } from "../lib/data";
import SectionNumber from "./SectionNumber";

const ICONS = { Users, Flame, Home, Sparkles };

export default function ExperienceCards() {
  return (
    <section
      data-testid="experience-section"
      className="relative bg-white py-24 sm:py-32 overflow-hidden"
    >
      <SectionNumber n="03" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-8 mb-16 sm:mb-20 items-end">
          <div className="md:col-span-7 reveal">
            <span className="eyebrow">Élmények</span>
            <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
              Négy út, egy<br />
              <span className="italic text-pkred">tűzbe.</span>
            </h2>
          </div>
          <div className="md:col-span-5 reveal">
            <p className="text-pkcharcoal/70 text-base sm:text-lg leading-relaxed">
              Akármi is hozott ide – falusi vendégasztal, kemencés est,
              pihenés vagy kézműves élmény – a tűz mindenkit megvár.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {EXPERIENCES.map((exp, idx) => {
            const Icon = ICONS[exp.icon];
            return (
              <div
                key={exp.title}
                data-testid={`experience-card-${idx}`}
                className="card-fire bg-white p-8 sm:p-9 relative group reveal"
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <div className="absolute top-6 right-6 text-pkash font-serif text-5xl leading-none group-hover:text-pkred/20 transition-colors">
                  0{idx + 1}
                </div>
                <div className="w-12 h-12 rounded-full bg-pkbeige flex items-center justify-center mb-6 group-hover:bg-pkred transition-colors duration-500">
                  <Icon
                    className="w-5 h-5 text-pkred group-hover:text-white transition-colors duration-500"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-serif text-2xl text-pkcharcoal leading-tight mb-3">
                  {exp.title}
                </h3>
                <p className="text-pkcharcoal/65 text-sm leading-relaxed">
                  {exp.desc}
                </p>
                <div className="mt-6 pt-6 border-t border-pkash flex items-center justify-between">
                  <span className="text-[0.7rem] tracking-[0.2em] uppercase text-pkcharcoal/50">
                    Élmény
                  </span>
                  <span className="text-pkred text-lg group-hover:translate-x-1 transition-transform">
                    →
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
